import { Box } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import CustomToolbar from '@/contexts/shared/components/CustomToolbar'
import { useSelector } from 'react-redux'
import useGetDataTable from '../hooks/useGetDataTable'
import { IRootState } from '@/redux/types'
import useModalState from '@/contexts/shared/hooks/useModalState'
import { useState } from 'react'
import ConfirmDeleteModal from './ConfirmDeleteModal'

function EventTable() {
  const { events } = useSelector((state: IRootState) => state.event)
  const {
    open: openConfirmDeleteModal,
    openModal: handleOpenConfirmDeleteModal,
    closeModal: handleCloseConfirmDeleteModal
  } = useModalState()
  const [eventSelected, setEventSelected] = useState(0)
  const { columns } = useGetDataTable(handleOpenConfirmDeleteModal, setEventSelected)

  return (
    <>
      <Box height={600}>
        <DataGrid
          rows={events}
          columns={columns}
          getRowId={row => row.id}
          disableRowSelectionOnClick
          pagination
          pageSizeOptions={[10, 20]}
          initialState={{
            pagination: { paginationModel: { page: 0, pageSize: 10 } }
          }}
          autoHeight
          density="comfortable"
          slots={{
            toolbar: CustomToolbar
          }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 }
            }
          }}
        />
      </Box>
      {openConfirmDeleteModal && (
        <ConfirmDeleteModal open={openConfirmDeleteModal} handleClose={handleCloseConfirmDeleteModal} eventSelected={eventSelected} />
      )}
    </>
  )
}

export default EventTable
